<template>
    <div id="main">
        <div class="page">
            <container-loader v-if="isLoading" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("despesas") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("despesas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                $router.push({
                                                    name: 'des-acerto-despesa-list',
                                                })
                                            "
                                        >
                                            {{ $t("prestacao-contas") }}
                                        </a>
                                    </li>
                                    <li>
                                        <a @click="redirectToList">
                                            {{ $t("prestacao-contas") }}
                                        </a>
                                    </li>
                                    <li>
                                        <a aria-current="page">
                                            {{ $t("despesas") }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                    </div>
                    <!-- BOTÕES DE AÇÃO -->
                    <div class="header-buttons">
                        <button 
                            class="delete-btn" 
                            type="button" 
                            tag="button" 
                            @click="promptChangePage"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button 
                            v-if="!cantEdit"
                            @click="salvarValida" 
                            class="save-btn" 
                            :disabled="
                                !(motivoDespesaSelected != null || permissao.create)
                            "
                        >
                            {{ $t("salvar") }}
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-multiline">
                        <div class="column is-6">
                            <vss-select 
                                :id="generateId(1)" 
                                ref="motivoDespesa" 
                                title="motivo-despesa"
                                :options="motivoDespesaSelect" 
                                v-model="motivoDespesaSelected"
                                :loading="motivoDespesaLoading"
                                label="descricao" 
                                :required="true" 
                                :invalid="motivoDespesaSelected==null"
                                placeholder="placeholder-preencha"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6" v-if="motivoDespesaSelected!=null">
                            <v-money 
                                :id="generateId(3)" 
                                ref="valordespesa"
                                :title="
                                motivoDespesaSelected.valormaximo && motivoDespesaSelected.despesaautomatica != 2 
                                    ? $t('valor-maximo-n', { 
                                        n:  getDecimal(motivoDespesaSelected.valormaximo, null, true) 
                                    }) 
                                    : $t('valor')"
                                placeholder="placeholder-preencha" 
                                required
                                v-model="despesa.valordespesa" 
                                :invalid="despesa.valordespesa == 0"
                                :max="
                                    (motivoDespesaSelected.despesaautomatica == 2)
                                    || 
                                    (motivoDespesaSelected.valormaximo == 0)
                                        ? 99999999999 
                                        : motivoDespesaSelected.valormaximo"
                                :disabled="
                                    motivoDespesaSelected.despesaautomatica > 0 || 
                                    cantEdit
                                " 
                                disableMLtitle
                            />
                        </div>
                        <!-- Campos personalizados -->
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.odometrohabilita==1"
                        >
                            <v-input 
                                :id="generateId(4)" 
                                ref="odometro" 
                                title="odometro"
                                type="number" 
                                v-model="despesa.odometro"
                                :maxlength="255" 
                                :required="motivoDespesaSelected.odometroobriga==1" 
                                :invalid="motivoDespesaSelected.odometroobriga==1 && !despesa.odometro" 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.distanciahabilita==1"
                        >
                            <v-input 
                                :id="generateId(5)" 
                                ref="distanciapercorrida" 
                                title="distancia"
                                type="number" 
                                v-model="despesa.distanciapercorrida"
                                :maxlength="255" 
                                :required="motivoDespesaSelected.distanciaobriga==1" 
                                :invalid="motivoDespesaSelected.distanciaobriga==1 && !despesa.distanciapercorrida" 
                                @input="valorKmPercorrido()"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.placahabilita==1"
                        >
                            <v-input 
                                :id="generateId(6)" 
                                ref="placaveiculo" 
                                title="placa"
                                v-model="despesa.placaveiculo"
                                :maxlength="50" 
                                :required="motivoDespesaSelected.placaobriga==1" 
                                :invalid="motivoDespesaSelected.placaobriga==1 && !despesa.placaveiculo" 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.estabelecimentohabilita==1"
                        >
                            <v-input 
                                :id="generateId(7)" 
                                ref="estabelecimento" 
                                title="estabelecimento"
                                v-model="despesa.estabelecimento"
                                :maxlength="255" 
                                :required="motivoDespesaSelected.estabelecimentoobriga==1" 
                                :invalid="motivoDespesaSelected.estabelecimentoobriga==1 && !despesa.estabelecimento" 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.centrocustohabilita==1"
                        >
                            <vss-select
                                :id="generateId(10)"
                                ref="centro_custo"
                                title="centrocusto"
                                searchable
                                :options="centrocustoSelect"
                                v-model="centrocustoSelected"
                                @search="carregarCentroCusto"
                                :loading="centrocustoLoading"
                                label="descricao" 
                                clearable
                                :required="motivoDespesaSelected.centrocustoobriga==1"
                                :invalid="motivoDespesaSelected.centrocustoobriga==1 && centrocustoSelected==null" 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.forma_pagamentohabilita==1"
                        >
                            <vss-select
                                :id="generateId(10)"
                                ref="forma_pagamento"
                                title="forma_pagamento"
                                searchable
                                :options="formaPagamentoSelect"
                                v-model="formaPagamentoSelected"
                                @search="carregarFormapagto"
                                :loading="formaPagamentoLoading"
                                label="descricao" 
                                clearable
                                :required="motivoDespesaSelected.forma_pagamentoobriga==1"
                                :invalid="
                                    motivoDespesaSelected.forma_pagamentoobriga==1 
                                    && formaPagamentoSelected==null
                                " 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-6" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.solicitar_reembolsohabilita==1"
                        >
                            <vss-select
                                :id="generateId(10)"
                                ref="solicitar_reembolso"
                                title="solicitar_reembolso"
                                :options="soliciarReembolsoSelect"
                                v-model="soliciarReembolsoSelected"
                                :mlLabels="true"
                                :required="motivoDespesaSelected.solicitar_reembolsoobriga==1"
                                :invalid="
                                    motivoDespesaSelected.solicitar_reembolsoobriga==1 
                                    && soliciarReembolsoSelected==null
                                " 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-12" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.obshabilita==1"
                        >
                            <v-textarea 
                                :id="generateId(8)" 
                                ref="observacaogeral" 
                                title="obs"
                                v-model="despesa.observacaogeral" 
                                :required="motivoDespesaSelected.obsobriga==1"
                                :invalid="motivoDespesaSelected.obsobriga==1 && !despesa.observacaogeral" 
                                :disabled="cantEdit"
                            />
                        </div>
                        <div 
                            class="column is-12" 
                            v-if="motivoDespesaSelected!=null && motivoDespesaSelected.fotohabilita==1"
                        >
                            <multiple-img-picker 
                                :id="generateId(9)" 
                                ref="foto"
                                :value="despesa.acertoDespesaItemFotoListActual"
                                title="anexe-a-imagem-do-seu-comprovante-de-despesa"
                                :subtitle="
                                    motivoDespesaSelected.fotoobriga 
                                        ? `(Quantidade Minima ${motivoDespesaSelected.qtdeminimafoto})` 
                                        : ''"
                                @uploadedFiles="obterFotosDespesa"
                                :required="motivoDespesaSelected.fotoobriga==1"
                                :invalid="
                                    motivoDespesaSelected.fotoobriga==1 
                                    && 
                                    (despesa.acertoDespesaItemFotoListNew.length 
                                    + despesa.acertoDespesaItemFotoListActual.length) < 
                                        motivoDespesaSelected.qtdeminimafoto
                                "
                                @removeActualImage="removeActualImage"
                                :disabled="cantEdit"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MotivoDespesaService from "@/services/despesas/MotivoDespesasService.js";
import ValoresKmService from "@/services/despesas/ValoresKmService.js";
import AcertoDespesaService from "@/services/despesas/AcertoDespesaService";
import AcertoDespesaItemService from "@/services/despesas/AcertoDespesaItemService";
import DespesaFormapagtoService from "@/services/despesas/DespesaFormapagtoService";
import CentroCustoService from "@/services/vendas/financeiro/CentroCustoService";
import AcertoDespesaItemValidation from "@/services/validations/despesas/AcertoDespesaItemValidation.js";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Message from "@/models/Message";
import MultipleImgPicker from "@/components/shared/form/MultipleImgPicker.vue";

export default {
    components: {
        ContainerLoader,
        MultipleImgPicker,
    },
    data() {
        return {
            serviceMotivoDespesa: new MotivoDespesaService(this.$http, this.$router),
            serviceAcertoDespesa: new AcertoDespesaService(this.$http, this.$router),
            serviceDespesa: new AcertoDespesaItemService(this.$http, this.$router),
            serviceValorKm: new ValoresKmService(this.$http, this.$router),
            serviceDespesaFormapagto: new DespesaFormapagtoService(this.$http, this.$router),
            serviceCentroCusto: new CentroCustoService(this.$http, this.$router),
            isLoading: false,
            cantEdit: true,
            isSupervisor: false,
            validation: new AcertoDespesaItemValidation([]),
            filters: {
                column: "descricao",
                order: "asc",
                queryFilter: "",
            },

            despesa: {
                iddes_acerto_despesa_item: null,
                iddes_acerto_despesa_itemerp: null,
                uuid: null,
                uuiddes_acerto_despesa: this.$route.params.uuid,
                iddespesa_motivo: null,

                estabelecimento: null,
                observacaogeral: null,
                odometro: 0,
                placaveiculo: null,
                valordespesa: 0,
                valormaximo: 99999999999,
                origem: 'WEB',
                qtdeminimafoto: 0,
                distanciapercorrida: 0,
                datahora: Date.now(),
                // vem do banco
                acertoDespesaItemFotoListActual: [],
                // vão ser cadastrados
                acertoDespesaItemFotoListNew: [],
                idfin_centro_custo: null,
                iddes_formapagto: null,
                solicitar_reembolso: 0,
                valorkm: 0,
                // Objetos
                finCentroCusto: null,
                despesamotivo: null,
                desFormapagto: null,
                // situação 3 é em criação
                situacao: 3,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
            },
            isChanged: false,
            isUpdate: false,
            permissao: {},
            getDecimal: this.getDecimal,

            acertoDespesa: null,
            
            motivoDespesaSelect: [],
            motivoDespesaSelected: null,
            motivoDespesaLoading: false,

            soliciarReembolsoSelect: [
                { label: "nao", id: 0 }, 
                { label: "sim", id: 1 }
            ],
            soliciarReembolsoSelected: { label: "nao", id: 0 },
            
            formaPagamentoSelect: [],
            formaPagamentoSelected: null,
            formaPagamentoLoading: false,

            centrocustoSelect: [],
            centrocustoSelected: null,
            centrocustoLoading: false,
        };
    },
    watch: {
        motivoDespesaSelected(val) {
            if(val != null) this.limpaCamposDesabilitados();
        }
    },
    created() {
        if (this.$route.params.iditem) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "prestacao-contas",
            "des-acerto-despesa"
        );

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'despesas' }
            });
        } else {
            this.carregarMotivoDespesa();
            this.getValorKmAtivo();
            if (this.isUpdate) {
                this.carregarDados();
            } else {
                this.cantEdit = false;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        removeActualImage(index) {
            this.despesa.acertoDespesaItemFotoListActual.splice(index, 1);
        },
        carregarMotivoDespesa(currentPage = 1) {
            this.motivoDespesaLoading = true;

            this.serviceMotivoDespesa
                .findAll(
                    this.filters.column,
                    this.filters.order,
                    currentPage - 1,
                    99999,
                    1,
                    this.filters.queryFilter
                )
                .then((r) => {
                    this.motivoDespesaSelect = r.content;
                    this.motivoDespesaSelect.forEach((motivo, index) => {
                        if (motivo.despesaautomatica == 1) {
                            this.motivoDespesaSelect.splice(index, 1)
                        }
                    })
                })
                .catch(_ => {
                    this.motivoDespesaSelect = [];
                    this.$root.showMessage("alert", "msg-erro-load");
                })
                .finally(_ => {
                    this.motivoDespesaLoading = false;
                })
        },
        obterFotosDespesa(fotos) {
            let temp_fotos = [];
            fotos.forEach((foto, i) => {
                temp_fotos[i] = {
                    nome: foto.fileName,
                    caminho: foto.url.replace(/^data:(.*,)?/, ''),
                    documentopda: {
                        nome_documento: foto.fileName,
                        url_documento: '',
                    },
                    situacao: 1,
                    datahora: Date.now(),
                    uuid: null,
                    tipo: 'F',
                };
            });
            this.despesa.acertoDespesaItemFotoListNew = temp_fotos;
        },
        

        getValorKmAtivo() {
            this.serviceValorKm
                .getKmAtivo(this.$store.state.user.idusuarioerp)
                .then((res) => {
                    if (res.content != null) {
                        this.despesa.valorkm = res.content.valor;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load");
                });
        },
        carregarFormapagto(query='') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)
            this.formaPagamentoLoading = true;
            this.serviceDespesaFormapagto
                .findAllCombo(query)
                .then((r) => {
                    this.formaPagamentoSelect = r.content;
                })
                .catch((e) => {
                    this.formaPagamentoSelect = [];
                    this.$root.showMessage("alert", "msg-erro-load");
                })
                .finally((_) => {
                    this.formaPagamentoLoading = false;
                });
        },
        carregarCentroCusto(query='') {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query)
            this.centrocustoLoading = true;
            this.serviceCentroCusto
                .findAllCombo(query)
                .then((r) => {
                    this.centrocustoSelect = r.content;
                })
                .catch((e) => {
                    this.centrocustoSelect = [];
                    this.$root.showMessage("alert", "msg-erro-load");
                })
                .finally((_) => {
                    this.centrocustoLoading = false;
                });
        },
        carregarDados() {
            this.isLoading = true;

            this.serviceDespesa
                .find(this.$route.params.iditem)
                .then(data => {
                    if(data.content) {
                        let desTemp = data.content;
                        this.despesa.iddes_acerto_despesa_item = 
                            desTemp.iddes_acerto_despesa_item;
                        this.despesa.iddes_acerto_despesa_itemerp = 
                            desTemp.iddes_acerto_despesa_itemerp;
                        this.despesa.uuid = desTemp.uuid;
                        this.despesa.uuiddes_acerto_despesa = 
                            desTemp.uuiddes_acerto_despesa;
                        this.despesa.iddespesa_motivo = desTemp.iddespesa_motivo;

                        this.despesa.estabelecimento = desTemp.estabelecimento;
                        this.despesa.observacaogeral = desTemp.observacaogeral;
                        this.despesa.odometro = desTemp.odometro;
                        this.despesa.placaveiculo = desTemp.placaveiculo;
                        this.despesa.valordespesa = desTemp.valordespesa;
                        this.despesa.valormaximo = desTemp.valormaximo;
                        this.despesa.origem = desTemp.origem;
                        this.despesa.qtdeminimafoto = desTemp.qtdeminimafoto;
                        this.despesa.distanciapercorrida = desTemp.distanciapercorrida;
                        this.despesa.datahora = desTemp.datahora;
                        this.despesa.acertoDespesaItemFotoListActual = 
                            desTemp.acertoDespesaItemFotoListActual || [];
                        this.despesa.acertoDespesaItemFotoListNew = 
                            desTemp.acertoDespesaItemFotoListNew || [];
                        this.despesa.idfin_centro_custo = desTemp.idfin_centro_custo;
                        this.despesa.iddes_formapagto = desTemp.iddes_formapagto;
                        this.despesa.solicitar_reembolso = desTemp.solicitar_reembolso;
                        this.despesa.valorkm = desTemp.valorkm;
                        this.despesa.finCentroCusto = desTemp.finCentroCusto || null;
                        this.despesa.despesamotivo = desTemp.despesamotivo || null;
                        this.despesa.desFormapagto = desTemp.desFormapagto || null;
                        this.despesa.replicapda = desTemp.replicapda;
                        this.despesa.situacao = desTemp.situacao;
                        this.despesa.latitude = desTemp.latitude;
                        this.despesa.longitude = desTemp.longitude;
                        this.despesa.lastfix = desTemp.lastfix;
                        this.despesa.tipogps = desTemp.tipogps;
                    }
                })
                .catch(e => {
                    this.$root.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(_ => { 
                    if(this.despesa.despesamotivo) {
                        this.motivoDespesaSelected = this.despesa.despesamotivo;
                    }
                    if(this.despesa.finCentroCusto) {
                        this.centrocustoSelected = this.despesa.finCentroCusto;
                    }
                    if(this.despesa.desFormapagto) {
                        this.formaPagamentoSelected = this.despesa.desFormapagto;
                    }
                    this.soliciarReembolsoSelected = 
                        this.soliciarReembolsoSelect[this.despesa.solicitar_reembolso];

                    this.carregarDadosAcertoDespesa(this.despesa.uuiddes_acerto_despesa);
                    
                    this.isLoading = false; 
                })
        },
        carregarDadosAcertoDespesa(uuid) {
            this.isLoading = true;
            this.serviceAcertoDespesa
                .findByUuid(uuid)
                .then(data => {
                    this.acertoDespesa = data.content;
                })
                .catch(e => {
                    this.acertoDespesa = null;
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally(_ => {
                    this.isLoading = false;
                    if (this.acertoDespesa != null) {
                        // Valida edição
                        this.cantEdit = (this.acertoDespesa.situacao != 3 ||
                            this.$store.state.user.usuario.id != this.acertoDespesa.idusuario);
                        // Valida se o usuário pode aprovar
                        let assusuariousuario = this.$store.state.user.usuario.assusuariousuarioList.map(m => m.idusuario);
                        this.isSupervisor = (this.$store.state.user.admin || 
                            assusuariousuario.includes(this.acertoDespesa.idusuario));
                    }
                });
        },
        valorKmPercorrido() {
            if (this.motivoDespesaSelected.despesaautomatica == 2) {
                this.despesa.valordespesa = 
                    this.despesa.distanciapercorrida * (this.despesa.valorkm / 1000);
            }
        },
        successPosition(position){
            this.despesa.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.despesa.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.despesa.lastfix = (position.timestamp)?position.timestamp:null;
            this.despesa.tipogps = (position.coords.latitude)?1:0;
            console.info(position);
            this.salvar();
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
            this.salvar();
        },
        salvarValida() {
            if (this.motivoDespesaSelected == null) {
                this.$refs.motivoDespesa.focusedOut = true;
                this.$root.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                return;
            }
            this.isLoading = true;

            if(!this.isUpdate) {
                // pega alocalização através do navegador caso esteja liberado
                if (navigator.geolocation) {
                    console.log('Geolocation is supported by this browser');
                    navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
                } else {
                    console.log('Geolocation is not supported by this browser');
                    this.salvar();
                }
            } else{
                this.salvar();
            }
        },
        salvar() {
            this.despesa = this.mapTosave(this.despesa, 'uuid', 'uuiddes_acerto_despesa');
            
            this.despesa.iddespesa_motivo = this.motivoDespesaSelected.id;
            this.despesa.qtdeminimafoto = this.motivoDespesaSelected.qtdeminimafoto;
            this.despesa.valormaximo = this.motivoDespesaSelected.valormaximo;
            this.despesa.descricaodespesa = this.motivoDespesaSelected.descricao;

            this.despesa.idfin_centro_custo = this.centrocustoSelected != null ? 
                this.centrocustoSelected.id : null;

            this.despesa.iddes_formapagto = this.formaPagamentoSelected != null ? 
                this.formaPagamentoSelected.id : null;

            this.despesa.solicitar_reembolso = this.soliciarReembolsoSelected != null ? 
                this.soliciarReembolsoSelected.id : 0;

            if(this.motivoDespesaSelected.fotohabilita == 0) {
                this.despesa.acertoDespesaItemFotoListNew = [];
                this.despesa.acertoDespesaItemFotoListActual = [];
            }

            if (this.validation.validate(
                this.despesa, this.motivoDespesaSelected, this.$refs
            )) {
                this.serviceDespesa
                    .save(this.despesa)
                    .then((r) => {
                        this.$root.showMessage("success", "msg-sucesso-salvar-despesa");
                        this.redirectToList(true);
                    })
                    .catch(_ => {
                        this.$root.showMessage("error", "msg-erro-salvar-despesa");
                    })
                    .finally(_ => {
                        this.isLoading = false;
                    });
            } else {
                this.$root.msgs.push(new Message("alert", 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        limpaCamposDesabilitados() {
            if(this.motivoDespesaSelected.odometrohabilita == 0) {
                this.despesa.odometro = 0;
            }
            if(this.motivoDespesaSelected.distanciahabilita == 0) {
                this.despesa.distanciapercorrida = 0;
            }
            if(this.motivoDespesaSelected.placahabilita == 0) {
                this.despesa.placaveiculo = null;
            }
            if(this.motivoDespesaSelected.estabelecimentohabilita == 0) {
                this.despesa.estabelecimento = null;
            }
            if(this.motivoDespesaSelected.centrocustohabilita == 0) {
                this.despesa.idfin_centro_custo = null;
                this.centrocustoSelected = null;
            }
            if(this.motivoDespesaSelected.forma_pagamentohabilita == 0) {
                this.despesa.iddes_formapagto = null;
                this.formaPagamentoSelected = null;
            }
            if(this.motivoDespesaSelected.solicitar_reembolsohabilita == 0) {
                this.despesa.solicitar_reembolso = 0;
                this.soliciarReembolsoSelected = this.soliciarReembolsoSelect[0];
            }
            if(this.motivoDespesaSelected.obshabilita == 0) {
                this.despesa.obs = null;
            }
            if(this.motivoDespesaSelected.fotohabilita == 0) {
                this.despesa.acertoDespesaItemFotoListNew = [];
            }
            
        },
        promptChangePage() {
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToList();
                    },
                });
            } else {
                this.redirectToList();
            }
        },
        redirectToList(isSave = false) {
            setTimeout(() => {
                let query = {abaSelecionada: 'despesas'};
                if (isSave) {
                    query.idmotivo = this.motivoDespesaSelected.id;
                } else if(this.$route.query && !this.isNull(this.$route.query.idmotivo)) {
                    query.idmotivo = this.$route.query.idmotivo;
                }
                this.$router.push(
                    { 
                        name: "des-acerto-despesa-edit",
                        params: {id: this.$route.params.id},
                        query: query,
                    }
                );
            }, 800);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>